<div class="w-full grid grid-cols-12 justify-end gap-4">
  <div class="col-span-12 md:col-span-6 lg:col-span-4 2xl:col-start-4 2xl:col-span-4">
    <p-multiselect
      fluid
      id="businessGroupFilter"
      [options]="businessGroupOptions()"
      [(ngModel)]="selectedBusinessGroups" 
      optionLabel="Name"
      optionValue="Id"
      [filter]="true"
      filterBy="Name"
      [showClear]="true"
      placeholder="Filtrar por grupo empresarial">
      <ng-template #selectedItem let-selectedOption>
        @if (selectedOption) {
          <app-business-logo
            [logoUrl]="selectedOption.LogoUrl"
            [name]="selectedOption.Name"
            logoSize="sm">
          </app-business-logo>
        }
      </ng-template>
      <ng-template let-business #item>
        <app-business-logo
          [logoUrl]="business.LogoUrl"
          [name]="business.Name"
          logoSize="sm">
        </app-business-logo>
      </ng-template>
    </p-multiselect>
  </div>

  <div class="col-span-12 md:col-span-6 lg:col-span-4 2xl:col-span-3">
    <input 
      pInputText fluid
      id="search" 
      [(ngModel)]="searchText"
      placeholder="Buscar"/>
  </div>

  <div class="col-span-12 md:col-span-6 lg:col-span-2 2xl:col-span-1">
    <p-button
      label="Filtrar"
      icon="pi pi-search"
      (onClick)="handleFilter()"
      type="button"
      fluid
    />
  </div>
    
  <div class="col-span-12 md:col-span-6 lg:col-span-2 2xl:col-span-1">
    <p-button
      label="Limpiar"
      icon="pi pi-times"
      severity="secondary"
      (onClick)="handleClear()"
      type="button"
      fluid
    />
  </div>
</div>